<template>
  <div>
    <div v-if="goods">
      <div v-if="isOuterScene">
        <!-- 榜单标签 -->
        <div
          v-if="isRating && goods.rankingNum && tagStyle != 'none'"
          class="simple-module-list-tag"
          :class="`simple-module-list-tag-no${goods.rankingNum}`"
        >
          <template v-if="tagStyle == 'ranking'">
            <span v-if="goods.rankingNum">{{ goods.subject_type === 1 ? "英雄" : "皮肤" }}</span>
            <div class="num">
              No.<i>{{ goods.rankingNum }}</i>
            </div>
          </template>
          <template v-else>
            <span v-if="goods.rankingNum">{{ goods.subject_type === 1 ? "英雄" : "皮肤" }}No.{{ goods.rankingNum }}</span>
            <p>{{ goods.avg_score }}</p>
          </template>
        </div>
        <!-- 热销标签 -->
        <div v-if="goods.hotTag && goods.hotIndex" class="simple-module-list-tag simple-module-list-tag-no1">
          <span>{{ goods.hotTag }}</span>
          <div class="num">
            No.<i>{{ goods.hotIndex }}</i>
          </div>
        </div>
        <img
          v-if="!goods.seckillActivity"
          v-lazy="useSmallIcon ? goods.icon : goods.hdIcon || goods.icon"
          class="active-img"
          :alt="goods.name"
          :onerror="placeholderBg"
        />
        <!-- 在王者小店场景下展示秒杀 -->
        <!-- 在商品列表展示，用goods.seckillActivity来区别秒杀物品 -->
        <div v-else class="spike-con">
          <div class="spike-goods spike-goods-ms"></div>
          <img
            v-lazy="useSmallIcon ? goods.icon : goods.hdIcon || goods.icon"
            class="active-img"
            :alt="goods.name"
            :onerror="placeholderBg"
          />
        </div>
        <div style="position: absolute; top: 0.08rem; left: 0.08rem">
          <div class="jf-tag jf-tag-obscure">{{ goods.tag }}</div>
        </div>
        <div class="active-detail">
          <p class="active-name jf-active-name">{{ goods.name }}</p>
          <!-- 现原价 一行 active-cost-style -->
          <div class="active-cost active-cost-style">
            <p class="active-cost--ticket">
              <span class="active-cost--now jf-txtColor-orange">
                <i class="icon-ticket jf-icon-ticket-size"
                  :style="{
                    backgroundImage: gameCoinIcon ? 'url(' + gameCoinIcon + ')' : '',
                    display: goods.showGameCoinPrice && salePriceDisplay ? 'inline-block' : 'none'
                  }"
                ></i>{{ salePriceDisplay }}</span>
            </p>
            <div v-if="goods.activityTag !== ''" class="jf-tag jf-tag-orange">{{ goods.activityTag }}</div>
            <!-- 商品有券就展示券标签，目前无法前置展示 -->
            <!-- <div class="jf-tag jf-tag-lightOrange">券</div> -->
          </div>
          <!-- 底部标签列表展示时默认展示前三个 并且过滤掉重复的第一个重复的tag-->
          <div v-if="goods.tags && goods.tags.filter(item => !!item).length > 1" class="jf-tag-list">
            <div v-for="(goodtags, i) in goods.tags.filter(item => !!item)" :key="i">
              <div v-if="i > 0 && i < 4" class="jf-tag jf-tag-yellow">{{ goodtags }}</div>
            </div>
          </div>
          <div v-else class="jf-tag-list">
            <p style="font-size: 10px" class="active-name-detail">{{ goods.goodsRemark }}</p>
          </div>
        </div>
      </div>
      <div v-else>
        <!-- 榜单标签 -->
        <div
          v-if="isRating && goods.rankingNum && tagStyle != 'none'"
          class="simple-module-list-tag"
          :class="`simple-module-list-tag-no${goods.rankingNum}`"
        >
          <template v-if="tagStyle == 'ranking'">
            <span v-if="goods.rankingNum">{{ goods.subject_type === 1 ? "英雄" : "皮肤" }}</span>
            <div class="num">
              No.<i>{{ goods.rankingNum }}</i>
            </div>
          </template>
          <template v-else>
            <span v-if="goods.rankingNum">{{ goods.subject_type === 1 ? "英雄" : "皮肤" }}No.{{ goods.rankingNum }}</span>
            <p>{{ goods.avg_score }}</p>
          </template>
        </div>
        <!-- 热销标签 -->
        <div v-if="goods.hotTag && goods.hotIndex" class="simple-module-list-tag simple-module-list-tag-no1">
          <span>{{ goods.hotTag }}</span>
          <div class="num">
            No.<i>{{ goods.hotIndex }}</i>
          </div>
        </div>
        <img
          :key="goods.name"
          v-lazy="useSmallIcon ? goods.icon : goods.hdIcon || goods.icon"
          class="active-img"
          :alt="goods.name"
          :onerror="placeholderBg"
        />
        <!-- vmall配置的运营标签 -->
        <p
          v-if="goods.activityTag && !blockOperations && type !== 'outer'"
          :class="['simple-module-item-tag', goods.activityTag ? goods.tagClass : '']"
        >
          {{ goods.activityTag }}
        </p>
        <p v-if="goods.recommTag && !blockOperations" class="simple-module-item-tag" :style="{ background: goods.tagColor }">
          <i>{{ goods.recommTag }}</i>
        </p>
        <slot name="inputRadio"></slot>
        <div v-if="type == 'outer'" class="active-detail">
          <div class="active-name_con">
            <!-- 有标签时 添加类max-w  -->
            <p class="active-name" :class="{ 'max-w': giftCardNums && giftCardNumTag(goods) }">{{ goods.name }}</p>
            <span v-if="giftCardNums && giftCardNumTag(goods)" class="tag-o">已拥有{{ giftCardNumTag(goods) }}张</span>
          </div>
          <div class="active-cost active-cost-style">
            <singlePropPriceHolder :goods="goods" :game-coin-icon="gameCoinIcon"></singlePropPriceHolder>
          </div>
          <p class="active-name-detail active-name-detail--style">
            {{ goods.recommendText }}
          </p>
        </div>

        <div v-else class="active-detail">
          <div class="active-name_con">
            <p class="active-name">
              <span v-if="name" class="active-name-tag">{{ name }}</span>
              <span class="active-name-content" :class="{ 'max-w': giftCardNums && giftCardNumTag(goods) }">
                {{ goods.name }}
              </span>
            </p>
            <span v-if="giftCardNums && giftCardNumTag(goods)" class="tag-o">已拥有{{ giftCardNumTag(goods) }}张</span>
          </div>
          <p class="active-name-detail active-name-detail-center">
            <span
              v-for="(tag, index) in goods.tags"
              :key="`tag${index}`"
              :class="[
                'mall-commodity-tag',
                goods.itemExtend && goods.itemExtend.ItemType === '13' ? 'mall-commodity-tag--green' : 'mall-commodity-tag--blue'
              ]"
              >{{ tag }}</span
            >
            <span class="active-name-detail-center-txt">{{ goods.remark }}</span>
          </p>
          <div v-if="!blockOperations" class="active-cost">
            <singlePropPriceHolder :goods="goods" :game-coin-icon="gameCoinIcon"></singlePropPriceHolder>
            <p class="active-cost--gold">
              <span v-if="goods && goods.saleInGameCoinPrice" class="active-cost--now">
                <i class="icon-gold"></i>{{ goods.saleInGameCoinPrice }}
              </span>
              <span v-if="goods.totalInGameCoinPrice" class="active-cost--old">{{ goods.totalInGameCoinPrice }}金币</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <img class="active-img" :src="placeholderBg" alt="­加载中" />
      <div class="active-detail">
        <p class="active-name"></p>
        <p class="active-name-detail"></p>
        <div class="active-cost">
          <p class="active-cost--ticket"><span class="active-cost--now"></span><span class="active-cost--old"></span></p>
          <p class="active-cost--gold"><span class="active-cost--now"></span><span class="active-cost--old"></span></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import singlePropPriceHolder from "./singlePropPriceHolder.vue"
import { mapGetters } from "vuex"
import * as langs from "@constants/langs.js"
import * as gameProps from "@api/gameProps"

export default {
  components: {
    singlePropPriceHolder: singlePropPriceHolder
  },
  /**
   * blockOperations 屏蔽产品运营内容，如价格、运营标签等（此种情况用于如仅展示纯商品信息的情况）
   */
  props: ["goods", "gameCoinIcon", "name", "blockOperations", "useSmallIcon", "type", "isRating", "tagStyle"],
  data() {
    return {
      placeholderBg: require("../../../../ui/assets/mobile/images/placeholder-bg.png")
    }
  },
  computed: {
    ...mapGetters(["giftCardNums"]),
    isOuterScene() {
      return gameProps.isOuterScene()
    },
    salePriceDisplay() {
      if (this.goods.saleChannelPrice) {
        return `${this.goods.saleChannelPrice}`
      } else if (this.goods.showGameCoinPrice) {
        return this.goods.salePrice
      } else {
        // 兼容价格为0，如果价格为0或空，则不显示￥
        return this.goods.saleCashRMBPrice ? `￥${this.goods.saleCashRMBPrice}` : ""
      }
    }
  },
  methods: {
    // 礼品卡数量标签
    giftCardNumTag(goods) {
      if (langs.GIFTCARD_AMSIDS.includes(goods?.itemExtend?.AMSID)) {
        return this.giftCardNums?.[goods?.itemExtend?.AMSID] || ""
      }
      return ""
    }
  }
}
</script>
